import { connect } from 'react-redux';
import ClickableImageComponent from '../Components/ClickableImageComponent.jsx';
import { auth as authActions, modal as modalActions } from '../actions';
import { auth, urls } from '../helpers';

export const mapStateToProps = (state) => {
  return {
    isActive: auth.checkAuthenticated(state),
    activeImageSource: urls.AUTH_CONNECTED_SRC,
    disabledImageSource: urls.AUTH_DISCONNECTED_SRC,
    marginRight: '-10px'
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onClick: () => {
      // signed in users get the modal to log out, others try single sign-on first
      const action = auth.checkAuthenticated() ?
        modalActions.showJiraLoginModal(true, false) :
        authActions.signInOrShowModal(false);
      return dispatch(action);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClickableImageComponent);


// WEBPACK FOOTER //
// src/Containers/LoginButtonContainer.jsx